module.exports = __webpack_public_path__ + "img/arrow-down.55c37772.svg";